import { m as n, a as t } from "./belt_Array-b9ebcaa6.mjs";

import { u as e, a as r } from "./caml_option-16487d6d.mjs";

function placeholder(n) {}

function make(n) {
  return String(n);
}

function length(n) {
  return n.length;
}

function _concat(n, t) {
  return n.concat(t);
}

function concat() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _concat(t, n[0]);
    };
  }
  return _concat(arguments[0], arguments[1]);
}

function _append(n, t) {
  return n.concat(t);
}

function append() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _append(t, n[0]);
    };
  }
  return _append(arguments[0], arguments[1]);
}

function _prepend(n, t) {
  return t.concat(n);
}

function prepend() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _prepend(t, n[0]);
    };
  }
  return _prepend(arguments[0], arguments[1]);
}

function _slice(n, t, e) {
  return n.slice(t, e);
}

function slice() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _slice(t, n[0], n[1]);
    };
  }
  return _slice(arguments[0], arguments[1], arguments[2]);
}

function _sliceToEnd(n, t) {
  return n.slice(t);
}

function sliceToEnd() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _sliceToEnd(t, n[0]);
    };
  }
  return _sliceToEnd(arguments[0], arguments[1]);
}

function toLowerCase(n) {
  return n.toLowerCase();
}

function toUpperCase(n) {
  return n.toUpperCase();
}

function trim(n) {
  return n.trim();
}

function trimStart(n) {
  return n.trimStart();
}

function trimEnd(n) {
  return n.trimEnd();
}

function isEmpty(n) {
  return 0 === n.length;
}

function isNotEmpty(n) {
  return n.length > 0;
}

function _split(n, t) {
  return n.split(t);
}

function split() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _split(t, n[0]);
    };
  }
  return _split(arguments[0], arguments[1]);
}

function _splitByRe(n, t) {
  return n.split(t);
}

function splitByRe() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _splitByRe(t, n[0]);
    };
  }
  return _splitByRe(arguments[0], arguments[1]);
}

function _splitAt(n, t) {
  return [ n.slice(0, t), n.slice(t) ];
}

function splitAt() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _splitAt(t, n[0]);
    };
  }
  return _splitAt(arguments[0], arguments[1]);
}

function _includes(n, t) {
  return n.includes(t);
}

function includes() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _includes(t, n[0]);
    };
  }
  return _includes(arguments[0], arguments[1]);
}

function _replace(n, t, e) {
  return n.replace(t, e);
}

function replace() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _replace(t, n[0], n[1]);
    };
  }
  return _replace(arguments[0], arguments[1], arguments[2]);
}

function _replaceAll(n, e, r) {
  var i = n.split(e);
  return t(i, "", (function(n, t, e) {
    var c = e < (i.length - 1 | 0) ? t.concat(r) : t;
    return n.concat(c);
  }));
}

function replaceAll() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _replaceAll(t, n[0], n[1]);
    };
  }
  return _replaceAll(arguments[0], arguments[1], arguments[2]);
}

function _replaceByRe(n, t, e) {
  return n.replace(t, e);
}

function replaceByRe() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _replaceByRe(t, n[0], n[1]);
    };
  }
  return _replaceByRe(arguments[0], arguments[1], arguments[2]);
}

function _remove(n, t) {
  return n.replace(t, "");
}

function remove() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _remove(t, n[0]);
    };
  }
  return _remove(arguments[0], arguments[1]);
}

function _removeAll(n, t) {
  return replaceAll(n, t, "");
}

function removeAll() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _removeAll(t, n[0]);
    };
  }
  return _removeAll(arguments[0], arguments[1]);
}

function _search(n, t) {
  var e = n.search(t);
  if (e < 0) {
    return;
  } else {
    return e;
  }
}

function search() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _search(t, n[0]);
    };
  }
  return _search(arguments[0], arguments[1]);
}

function _match(n, t) {
  return r(n.match(t));
}

function match() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _match(t, n[0]);
    };
  }
  return _match(arguments[0], arguments[1]);
}

function _repeat(n, t) {
  return n.repeat(t);
}

function repeat() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _repeat(t, n[0]);
    };
  }
  return _repeat(arguments[0], arguments[1]);
}

function _indexOf(n, t) {
  var e = n.indexOf(t);
  if (e < 0) {
    return;
  } else {
    return e;
  }
}

function indexOf() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _indexOf(t, n[0]);
    };
  }
  return _indexOf(arguments[0], arguments[1]);
}

function _lastIndexOf(n, t) {
  var e = n.lastIndexOf(t);
  if (e < 0) {
    return;
  } else {
    return e;
  }
}

function lastIndexOf() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _lastIndexOf(t, n[0]);
    };
  }
  return _lastIndexOf(arguments[0], arguments[1]);
}

function _endsWith(n, t) {
  return n.endsWith(t);
}

function endsWith() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _endsWith(t, n[0]);
    };
  }
  return _endsWith(arguments[0], arguments[1]);
}

function _startsWith(n, t) {
  return n.startsWith(t);
}

function startsWith() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _startsWith(t, n[0]);
    };
  }
  return _startsWith(arguments[0], arguments[1]);
}

function _getUnsafe(n, t) {
  return n[t];
}

function getUnsafe() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _getUnsafe(t, n[0]);
    };
  }
  return _getUnsafe(arguments[0], arguments[1]);
}

function _get(n, t) {
  return e(n[t]);
}

function get() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _get(t, n[0]);
    };
  }
  return _get(arguments[0], arguments[1]);
}

function toArray(t) {
  return n(t.length, (function(n) {
    return t[n];
  }));
}

function head(n) {
  return e(n[0]);
}

function last(n) {
  return e(n[n.length - 1 | 0]);
}

var i = {
  __proto__: null,
  placeholder,
  make,
  length,
  concat,
  append,
  prepend,
  slice,
  sliceToEnd,
  toLowerCase,
  toUpperCase,
  trim,
  trimStart,
  trimEnd,
  isEmpty,
  isNotEmpty,
  split,
  splitByRe,
  splitAt,
  includes,
  replace,
  replaceAll,
  replaceByRe,
  remove,
  removeAll,
  search,
  match,
  repeat,
  indexOf,
  lastIndexOf,
  endsWith,
  startsWith,
  getUnsafe,
  get,
  toArray,
  head,
  last
};

export { match as A, repeat as B, indexOf as C, lastIndexOf as D, endsWith as E, startsWith as F, getUnsafe as G, get as H, toArray as I, head as J, last as K, append as a, prepend as b, concat as c, sliceToEnd as d, toUpperCase as e, trim as f, trimStart as g, trimEnd as h, i, isEmpty as j, isNotEmpty as k, length as l, make as m, split as n, splitByRe as o, placeholder as p, splitAt as q, includes as r, slice as s, toLowerCase as t, replace as u, replaceAll as v, replaceByRe as w, remove as x, removeAll as y, search as z };
